import { CommonModule } from "@angular/common";
import { OrderWizardService } from "../../../_service/order-wizard.service";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CorpCardComponent, CorpLoadingComponent } from "@corporate-tailwind/component";
import { Component, computed, effect, OnDestroy, OnInit } from "@angular/core";
import { CustomerDto, CustomerDtoForValidation } from "../../../../model/customer.model";
import { FormGroup } from "@angular/forms";
import { CorpTranslateService } from "@corporate-tailwind/translation";
import { BusinessExceptionMessage } from "src/app/shared/model/business-exception.model";
import { ItsMeEmailValidationComponent } from "../email-validation/itsme-email-validation.component";
import { ItsMeCustomerExceptionSummaryComponent } from "../customer-exception-summary/itsme-customer-exception-summary.component";
import { ItsMeEmailAskValidationComponent } from "../email-ask-validation/itsme-email-ask-validation.component";

@Component({
    selector: 'itsme-customer-summary',
    imports: [CommonModule, TranslateModule, CorpLoadingComponent, CorpCardComponent, ItsMeEmailValidationComponent, ItsMeCustomerExceptionSummaryComponent, ItsMeEmailAskValidationComponent],
    templateUrl: './itsme-customer-summary.component.html',
    styleUrls: ['./itsme-customer-summary.component.scss'],
    animations: [ ]
})
export class ItsMeCustomerSummaryComponent implements OnInit, OnDestroy {
customerDto: CustomerDto | null = null;
businessException: BusinessExceptionMessage[] | null = null;
businessCustomerExceptions: BusinessExceptionMessage[] | null = null;
businessIdentityExceptions: BusinessExceptionMessage[] | null = null;
form: FormGroup | null = null;
tab: 'profile' | 'identity' | 'emailValidation' | 'askEmailValidation' | 'exception' = 'profile';
today = new Date();
yesterday = new Date(this.today);

    constructor(
        public _orderWizardService: OrderWizardService,
        private _translateService: TranslateService,
        private _corpTranslateService: CorpTranslateService
    ) {
        this.yesterday.setDate(this.today.getDate() - 1);

        effect(() => {
            this.customerDto = this._orderWizardService.orderWizard$()?.step03?.customerDto ?? null;
            this.businessException = this._orderWizardService.orderWizard$()?.step03?.businessExceptionMessages ?? null;

            this.tab = (this.businessException?.length ?? 0) > 0
                ? 'exception' 
                :  !this.customerDto?.isMailConfirmed 
                    ? 'emailValidation'
                    : !this.customerDto?.isAskMailConfirmed
                        ? 'profile'
                        : 'askEmailValidation'
        });

        this.businessCustomerExceptions = this.businessException?.filter(x => x.code?.includes('CUST')) ?? null;
        this.businessIdentityExceptions = this.businessException?.filter(x => x.code?.includes('IDPROOF')) ?? null;

        this.form = this._orderWizardService.formGroup;
    }


    ngOnInit(): void {

    }

    ngOnDestroy(): void {

    }

    hasExceptionCode(exceptionCode: string): boolean {
        return this.businessException?.some(x => x.code === exceptionCode) ?? false;
    }

    hasCustomerExceptionCode(): boolean {
        return (
            this.businessException?.some(x => x.code === 'BUS_CUST_001')
            ||
            this.businessException?.some(x => x.code === 'BUS_CUST_002')
            ||
            this.businessException?.some(x => x.code === 'BUS_CUST_003')
            ||
            this.businessException?.some(x => x.code === 'BUS_CUST_004')
            ||
            this.businessException?.some(x => x.code === 'BUS_CUST_005')
            ||
            this.businessException?.some(x => x.code === 'BUS_CUST_006')
            ||
            this.businessException?.some(x => x.code === 'BUS_CUST_007')
            ||
            this.businessException?.some(x => x.code === 'BUS_CUST_008')
            ||
            this.businessException?.some(x => x.code === 'BUS_CUST_009')
        ) ?? false;
    }

    hasIdentityExceptionCode(): boolean {
        return (
            this.businessException?.some(x => x.code === 'BUS_IDPROOF_001')
            ||
            this.businessException?.some(x => x.code === 'BUS_IDPROOF_002')
            ||
            this.businessException?.some(x => x.code === 'BUS_IDPROOF_003')
            ||
            this.businessException?.some(x => x.code === 'BUS_IDPROOF_004')
            ||
            this.businessException?.some(x => x.code === 'BUS_IDPROOF_005')
            ||
            this.businessException?.some(x => x.code === 'BUS_IDPROOF_006')
            ||
            this.businessException?.some(x => x.code === 'BUS_IDPROOF_007')
            ||
            this.businessException?.some(x => x.code === 'BUS_IDPROOF_008')
        ) ?? false;
    }

}